import { useAuth0 } from '../auth/authCompat';

const NAMESPACE = 'https://rngroyale-namespace/';

export default function useTwitchUsernameFromAuth0() {
  const { user } = useAuth0();
  const twitchUsername = user?.[`${NAMESPACE}username`];
  return twitchUsername || '';
}
